import React, { ReactElement } from 'react';
import { Show } from '@chakra-ui/react';
import ButtonSwitch from '../components/ButtonSwitch/ButtonSwitch';
import { FlexWrapper } from '../styles/Toggle.styles';

const Wrapper = ({ children }: { children?: ReactElement }) => (
  <Show below="md">
    <FlexWrapper>{children}</FlexWrapper>
  </Show>
);

export const TemplateToggle = [
  { name: 'wrapper', component: <Wrapper /> },
  { name: 'buttonSwitch', component: <ButtonSwitch /> },
];

export default TemplateToggle;
